// extracted by mini-css-extract-plugin
module.exports = {"defaultLinkStyle":"OwnListingLink_defaultLinkStyle__2IHCu"};